<i18n>
{
    "en":{
        "game_name": "Cookie Run: Kingdom",
        "game_description": " ",
        "key_feature": "Key features",
        "feature1": "24x7 Auto production manager, easy 1% in Golden Age of Trade",
        "feature2": "Guild checkin, alliance battle, purchase guild relics",
        "feature3": "Auto cookie/kingdom research in gnome lab",
        "feature4": "PvP with specific power opponents, achieve master easily",
        "feature5": "Set safety stock and auto sending wishes",
        "feature6": "Collect daily rewards, fountain, hot air ballon, trains and tropical islands",
        "feature7": "Loading trade ships, balance aurora materials and trade in seaside market",
        "already_trying": "Start playing",
        "apply_free_trial": "Try for FREE",
        "go_simple_tutorial": "Quick start guide",
        "quickGuideURL": "https://cookierunkingdom.app/en/xrobotmon-tutorial",
        "subscribe": "Subscribe Now"
    },
    "zhHant":{
        "game_name": "薑餅人王國",
        "game_description": " ",
        "key_feature": "主要特點",
        "feature1": "24x7 全自動生產，輕鬆大貿易，馬上體驗慣老闆",
        "feature2": "公會打卡、守護之戰、公會文物自動買",
        "feature3": "地精實驗室，王國及餅乾自動升級",
        "feature4": "自動競技場欺負弱小，輕鬆變大師",
        "feature5": "自動送許願樹並可設定安全數量",
        "feature6": "自動每日禮、噴泉、熱氣球、小火車、熱帶島嶼收資源",
        "feature7": "貿易港上貨、自動平衡極光材料、商店必買不錯過",
        "already_trying": "開始玩囉",
        "apply_free_trial": "馬上免費試用！",
        "go_simple_tutorial": "簡易使用教學",
        "quickGuideURL": "https://cookierunkingdom.app/zh/xrobotmon-tutorial",
        "subscribe": "馬上訂閱！"
    },
    "ja":{
        "game_name": "クッキーラン：キングダム",
        "game_description": " ",
        "key_feature": "主な機能",
        "feature1": "24時間ずっと生産と在庫を自動で管理し、大貿易時代の上位1%も狙えます",
        "feature2": "ギルドチェックイン・守りの戦域・ギルドの遺物の購入も自動で",
        "feature3": "シュガーノーム研究所で王国とクッキーを自動研究",
        "feature4": "相手の戦力を指定してキングダムアリーナに自動で参加し、マスター段位も楽々獲得",
        "feature5": "材料を残す数を決めるだけで、願いの樹の願いを自動で叶える",
        "feature6": "デイリー報酬・恵みの噴水・くまゼリー気球・ゼリー列車を自動回収",
        "feature7": "貿易船への積み込み、オーロラ素材の交換、浜辺交易所での購入も自動で",
        "already_trying": "スタート",
        "apply_free_trial": "無料で試してみる",
        "go_simple_tutorial": "基本的な使い方",
        "quickGuideURL": "https://cookierunkingdom.app/ja/xrobotmon-tutorial",
        "subscribe": "今すぐ登録する！"
    },
    "ko":{
        "game_name": "쿠키런: 킹덤",
        "game_description": " ",
        "key_feature": "주요 특징",
        "feature1": "24시간 쉬지않고 자동으로 매크로가 돌아갑니다.",
        "feature2": "토벌전과 수호의 성전  진행과 길드 유물 구입을 자동으로 해줍니다.",
        "feature3": "설탕노움의 연구소에서 왕국연구와 쿠키연구를 자동으로 연구해줍니다.",
        "feature4": "킹덤 아레나에서 설정한 수치보다 약한 상대를 자동으로 대결해주며, 쉽게 마스터에 달성할 수 있습니다.",
        "feature5": "자동으로 소원나무를 전달하고, 최저 안전수량을 설정 할 수 있습니다.",
        "feature6": "자동으로 무료보상, 풍요의 분수, 곰젤리 열기구, 곰젤리 열차, 트로피컬 소다제도등의 보상을 수령합니다.",
        "feature7": "해상무역센터에서 자동으로 선적을 진행하고, 오로라 재료를 균형있게 상점에서 구매해 줍니다.",
        "already_trying": "시작하기",
        "apply_free_trial": "무료 체험하기",
        "go_simple_tutorial": "사용 방법",
        "quickGuideURL": "https://cookierunkingdom.app/ko/xrobotmon-tutorial",
        "subscribe": "구독하기"
    }
}

</i18n>
<template>
  <div>
    <v-card class="mx-auto elevation-0 transparent">
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex xs9>
            <div class="title">{{ $t('game_name') }}</div>
          </v-flex>
          <v-flex xs3>
            <v-avatar tile size="80">
              <GameLogo :imageUrl="cookingKingdomLogoUrl" :width="80" :height="80" />
            </v-avatar>
          </v-flex>
        </v-layout>
      </v-card-title>
      <iframe
        v-if="!small"
        style="width: 100%; min-height: 200px"
        src="https://www.youtube.com/embed/p9MdHtDcSHI"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <v-card-text v-if="!small">
        <v-list dense style="background: none" subheader>
          <v-subheader>{{ $t('key_feature') }}</v-subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-1-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature1') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-2-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature2') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-3-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature3') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-4-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature4') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-5-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature5') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-6-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature6') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-7-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature7') }}</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
      <v-card-actions v-if="!small">
        <v-btn color="green lighten-2" block dark outline :href="$t('quickGuideURL')" target="_blank">{{
          $t('go_simple_tutorial')
        }}</v-btn>
      </v-card-actions>
      <v-card-actions v-if="mode === 'trial'">
        <v-btn color="blue lighten-2" block dark @click="getTrial">
          {{ $t('apply_free_trial') }}
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn color="blue lighten-2" block dark @click="subscribe">{{ $t('subscribe') }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import assetMisc from '../assets/misc';
import GameLogo from '../components/ui/GameLogo.vue';

export default {
  name: 'CookieKingdomIntro',
  components: {
    GameLogo,
  },
  props: {
    mode: {
      type: String,
      default: 'trial', // 'trial' 'subscribe'
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      cookingKingdomLogoUrl: assetMisc.cookieKingdomLogoUrl,
    };
  },
  methods: {
    isEmpty(x) {
      return isEmpty(x);
    },
    getTrial() {
      this.$router.push(`/trial/cookieKingdom`);
    },
    subscribe() {
      this.$router.push(`/plan/cookieKingdom`);
    },
  },
};
</script>
